// extracted by mini-css-extract-plugin
export var divider = "_qb-0";
export var systemMessage = "_qb-1";
export var systemMessageWrapper = "_qb-2";